import React from 'react';
import {cn} from "../../lib/utils";

type ButtonVariant = "filledOrange" | "outlineOrange" | "filledWhite" | "outlineWhite" |  "outlineWhiteNoHover" ;


export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: ButtonVariant;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    onClose?: () => void;
}

export const Button: React.FC<ButtonProps> = ({variant = "filledOrange", className, children, type = "button", onClick, onClose, ...props}) => {
    const baseClasses =
        "inline-flex items-center justify-center select-none rounded-none border text-[16px] lg:text-[18px] font-bold uppercase transition-colors disabled:pointer-events-none disabled:opacity-50 cursor-pointer rounded-[5px]";

    const variantClasses: Record<ButtonVariant, string> = {
        filledOrange: "border-custom-orange bg-custom-orange text-white hover:bg-custom-orange/90",
        outlineOrange: "border-custom-orange bg-white text-custom-orange hover:bg-custom-orange/5",
        filledWhite: "border-white bg-white text-black",
        outlineWhite: "border-white bg-transparent text-white hover:bg-white hover:text-black",
        outlineWhiteNoHover: "border-white bg-transparent text-white",
    };

    return (
        <button
            type={type}
            className={cn(baseClasses, variantClasses[variant], className)}
            onClick={onClick ?? (onClose ? (() => onClose()) : undefined)}
            {...props}
        >
            {children}
        </button>
    );
};